<template>
  <div>
    <span class="active-line bg-black" :style="{transform: 'translateY('+this.$store.state.transPanelMenu+'px)'}"></span>
    <sidebar-link to="/home" fasClass="fa-tachometer-alt" label="Dashboard"></sidebar-link>
    <sidebar-link to="/product" fasClass="fa-archive" label="Product"></sidebar-link>
    <sidebar-link to="/transaction" fasClass="fa-exchange-alt" label="Transaction"></sidebar-link>
    <sidebar-link to="/marketing" fasClass="fa-bullhorn" label="Marketing"></sidebar-link>
    <sidebar-link to="/plugin" fasClass="fa-puzzle-piece" label="Plugin"></sidebar-link>
    <sidebar-link to="/theme" fasClass="fa-paint-roller" label="Theme"></sidebar-link>
    <sidebar-link to="/user" fasClass="fa-user-friends" label="User"></sidebar-link>
    <sidebar-link to="/setting" fasClass="fa-cog" label="Setting"></sidebar-link>
  </div>
</template>

<script>
import SidebarLink from './SidebarLink';
export default {
  components: {
    SidebarLink
  },
  watch: {
    $route() {
        // console.log(this.$store.state.transPanelMenu)
          
    },
  },
}
</script>

<style>

</style>